import { useContext, useEffect, useState } from 'react';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { GoodsParamsContext } from '../../../context/GoodsParamsContext';

export const useLogViewGoodsOptionModal = (params: {
  mode: 'purchase' | 'gift';
  isShowOnce: boolean;
  fromButton?: string;
}) => {
  const sno = useGoodsSno();
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const injected = useContext(GoodsParamsContext);

  const [isLogged, setIsLogged] = useState(false);
  useEffect(() => {
    if (isLogged) return;
    if (params.isShowOnce) return;

    logGoodsAnalytics({
      name: 'VIEW_GOODS_OPTION_MODAL',
      analytics: {
        // 찜탭 등 route 밖 진입은 AnalyticsContext 가 닿지 않으므로 SCREEN 을 직접 주입.
        ...(injected?.logging ? { SCREEN: injected.logging.screen } : {}),
        ...(params.mode === 'gift'
          ? { KIND: 'GIFT', FROM_BUTTON: params.fromButton ?? '' }
          : { FROM_BUTTON: params.fromButton ?? 'PURCHASE_BUTTON' }),
      },
    });

    setIsLogged(true);
  }, [
    injected,
    isLogged,
    logGoodsAnalytics,
    params.isShowOnce,
    params.mode,
    params.fromButton,
    sno,
  ]);
};
